import react from '../assets/react.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  profile,
  circle,
  react, 
  javascript, 
  node,
  logo
};